import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const PublishHubDialogLoadable: LoadableType<
	{
		onPublish: (arg: any) => Promise<void>;
		savingInProgress: boolean;
	} & Pick<DialogsContainerProps, 'onClose'>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PublishHubDialogLoadable" */ './PublishHubDialog.tsx'
			)
		).PublishHubDialog,
});
